import { createAsyncThunk } from '@reduxjs/toolkit';
import type { HttpError } from '@wix/yoshi-flow-bm';
import {
  ConnectStatus,
  type UpdateUserResponse,
  type User,
} from '@wix/ambassador-adsense-v1-adsense-user/types';
import { toggleConnectedAdUnit } from '@app/services';
import { type RootState } from '@app/settings-store';
import settingsParams from '@app/settingsParams';
import { selectAdsenseUser, selectAdUnitId } from '..';
import type { StoreExtraArgs } from '../../../types';

/** Probably replace to serverless */
export const fetchToggleConnectedAdUnit = createAsyncThunk<
  UpdateUserResponse,
  { reportingDimensionId: string; displayName?: string },
  { extra: StoreExtraArgs; rejectValue: string }
>(
  'fetchToggleConnectedAdUnit/GET',
  async ({ reportingDimensionId, displayName }, { extra, rejectWithValue, getState }) => {
    const { httpClient, wixSdk, settings } = extra as StoreExtraArgs;
    const state = getState() as RootState;

    const origCompId = wixSdk.getOrigCompId();
    const prevConnectedAdUnitId = selectAdUnitId(state, origCompId)!;

    try {
      const instanceId = wixSdk.getInstanceId();
      const prevUser: User | undefined = selectAdsenseUser(state)!;
      if (!prevUser) {
        throw rejectWithValue('User data not found.');
      }
      const data = await toggleConnectedAdUnit(
        reportingDimensionId,
        prevConnectedAdUnitId,
        prevUser,
        origCompId,
        instanceId,
        httpClient,
        displayName,
      );

      const connectStatus =
        data.adsenseUser?.user?.adsenseInfo?.connectStatus ??
        ConnectStatus.DISCONNECTED;
      settings.set(settingsParams.connectStatus, connectStatus);

      return data;
    } catch (e) {
      const error = e as HttpError;
      const message = error.response?.data?.message || error.message;
      throw rejectWithValue(message);
    }
  },
);
